export default {"src":"/_next/static/media/Gym.039deb03.svg","height":570,"width":1272,"blurWidth":0,"blurHeight":0};